export class NewUserNotAvailableError extends Error {
    constructor() {
        super(...arguments);
        this.code = 'NewUserNotAvailableError';
    }
}
export class MissingCognitoConfigError extends Error {
    constructor() {
        super(...arguments);
        this.code = 'MissingCognitoConfigError';
    }
}
export class UserDoesNotExistError extends Error {
    constructor() {
        super(...arguments);
        this.code = 'UserDoesNotExistError';
    }
}
